export const ClassificationMap = new Map([
    ['AC', 'ac'],
    ['BM', 'bm'],
    ['DE', 'de'],
    ['EK', 'missing'],
    ['EU', 'ek'],
    ['FAA', 'faa'],
    ['FT', 'ft'],
    ['GF', 'missing'],
    ['GM', 'missing'],
    ['GI', 'missing'],
    ['GT', 'file'],
    ['GTS', 'file'],
    ['HL', 'missing'],
    ['K', 'k'],
    ['KS', 'ks'],
    ['LF', 'missing'],
    ['LL', 'missing'],
    ['MS', 'ms'],
    ['NH', 'nh'],
    ['RA', 'missing'],
    ['SE', 'se'],
    ['SF', 'missing'],
    ['SG', 'file'],
    ['SGB', 'file'],
    ['SS', 'ss'],
    ['SU', 'su'],
    ['SUB', 'su'],
    ['SV', 'sv'],
    ['UT', 'ut'],
    ['V', 'missing'],
    ['EB', 'eb'],
    ['SL', 'sl'],
    ['MK', 'file'],
]);
export const FileClassificationMap = new Map([
    ['GT', require('styles/images/icon-gt.svg')],
    ['GTS', require('styles/images/icon-gt.svg')],
    ['SG', require('styles/images/icon-sg.svg')],
    ['SGB', require('styles/images/icon-sg.svg')],
    ['MK', require('styles/images/matkontakt.svg')],
]);
